import $ from 'jquery';


class AssetPreview {
	
	constructor() {

		$("#assetPreviewModal").on('hidden.bs.modal', () => {
	        $("#video_preview").html("");
	    });


		$("#assetPreviewModalLabel a").click(function(ee) {
	        ee.preventDefault();
	        $("#assetPreviewModalLabel").hide();
	        $("#asset_name_edit").show();
	        $("#newname").val($("#asset_title").html()).select();
	    });

	    $("#newcancel").click(function(e) {
	        e.preventDefault();
	        $("#asset_name_edit").hide();
	        $("#assetPreviewModalLabel").show();
	    });




	}


}

export default AssetPreview;

